import Api from './api'

const resource = '/categories'
export default {
  get() {
    return Api.get(`${resource}/index`)
  },
  create(data) {
    return Api.put(`${resource}/store`, data)
  },
  reorder(data) {
    return Api.post(`${resource}/reorder`, data)
  },
  update(categorySlug, data) {
    return Api.patch(`${resource}/update/${categorySlug}`, data)
  },
  destroy(categorySlug) {
    return Api.delete(`${resource}/destroy/${categorySlug}`)
  }
}
